import { EbookTab } from './EbookTab'
import { withEbookTab } from './withEbookTab'

const Connected = withEbookTab(EbookTab)

export { Connected as EbookTab }
